import { chunk, flatten } from 'lodash-es'
import {
  PartImageRequestItem,
  PartImageResponseItem,
} from 'src/api/searchResults/interfaces'
import CatalogServiceProvider from 'src/services/CatalogServiceProvider'
import { SearchResultsResponse } from 'src/store/models/SearchModels'

export const fetchMissedImages = async (
  data: SearchResultsResponse
): Promise<PartImageResponseItem[]> => {
  const missedImagesBatch: PartImageRequestItem[] = []
  ;(data.parts ?? []).forEach((item) => {
    if (!item.partImages || item.partImages.length < 1) {
      if (typeof item.orderNumber === 'number' && item.orderNumber > 0) {
        missedImagesBatch.push({
          orderNumber: item.orderNumber,
          partNumber: item.partNumber,
        })
      }
    }
    item.replacementParts?.forEach((replacementItem) => {
      if (
        (!replacementItem.partImages ||
          replacementItem.partImages.length < 1) &&
        typeof replacementItem.orderNumber === 'number' &&
        replacementItem.orderNumber > 0
      ) {
        missedImagesBatch.push({
          orderNumber: replacementItem.orderNumber,
          partNumber: replacementItem.partNumber,
        })
      }
    })
    item.alternateParts?.forEach((replacementItem) => {
      if (
        (!replacementItem.partImages ||
          replacementItem.partImages.length < 1) &&
        typeof replacementItem.orderNumber === 'number' &&
        replacementItem.orderNumber > 0
      ) {
        missedImagesBatch.push({
          orderNumber: replacementItem.orderNumber,
          partNumber: replacementItem.partNumber,
        })
      }
    })
  })

  if (missedImagesBatch.length === 0) {
    return []
  }

  const chunks = chunk(missedImagesBatch, 20)
  return Promise.all(
    chunks.map((missedImages) =>
      CatalogServiceProvider.getPartImages(missedImages)
    )
  ).then((updatedPartChunks) => flatten(updatedPartChunks))
}

export const mergeMissedImages = (
  data: SearchResultsResponse,
  partImages: PartImageResponseItem[]
): SearchResultsResponse => {
  if (partImages.length === 0) {
    return data
  }

  const parts = (data.parts ?? []).map((item) => {
    if (!item.partImages || item.partImages.length < 1) {
      const image = partImages.find(
        (img) =>
          img.partNumber === item.partNumber &&
          img.orderNumber === item.orderNumber.toString()
      )

      const replacementParts = item.replacementParts?.map((replacementItem) => {
        const replacementImage = partImages.find(
          (img) =>
            img.partNumber === replacementItem.partNumber &&
            img.orderNumber === replacementItem.orderNumber.toString()
        )

        return {
          ...replacementItem,
          partImages: replacementImage?.partImages,
        }
      })

      const alternateParts = item.alternateParts?.map((replacementItem) => {
        const replacementImage = partImages.find(
          (img) =>
            img.partNumber === replacementItem.partNumber &&
            img.orderNumber === replacementItem.orderNumber.toString()
        )

        return { ...replacementItem, partImages: replacementImage?.partImages }
      })

      return {
        ...item,
        partImages: image?.partImages,
        replacementParts,
        alternateParts,
      }
    }
    return item
  })

  return { ...data, parts }
}
